













import Component from "vue-class-component";
import Vue from "vue";
import { Prop, VModel } from "vue-property-decorator";
import { value } from "@/models/CustomTypes";

@Component
export default class NumberInput extends Vue {
  @Prop({ default: "" }) label: string;
  @Prop({ default: "" }) suffix: string;
  @Prop({ default: true }) dense: boolean;
  @Prop({ default: false }) outlined: boolean;
  @Prop({ default: () => [] }) rules: [];
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) returnObject: boolean;
  @Prop({ default: "" }) icon: boolean;
  @VModel({ type: [Number, Object] }) localValue: value;
}
